import { render, staticRenderFns } from "./ApproveRegularizationModal.vue?vue&type=template&id=207f490e&"
import script from "./ApproveRegularizationModal.vue?vue&type=script&lang=js&"
export * from "./ApproveRegularizationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports